module.exports = __webpack_public_path__ + "static/img/01.95586b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/about/01.jpg
// module id = 21
// module chunks = 0